<script>
  import { format } from '../lib/utils.js';
  import { categoriesById } from '../lib/categories';
  export let r;
  export let x;
  export let y;
  export let d;
  export let label;
  export let hovering;
  export let hovered;


  let color = categoriesById[d.category].color;

  let circle;
  let hover = false;
  let pos = 'default';

  function mouseover() {
    const r = circle.getBoundingClientRect();

    if (r.left < 115) {
      pos = 'left';
    } else if (r.right > window.innerWidth - 115) {
      pos = 'right';
    } else {
      pos = 'default';
    }

    hover = true;
  }

  function mouseout() {
    hover = false;
  }

  const hoverR = 6;

  const frmt = format(2, true);


</script>

<div
  class="food"
  class:hover={hover}
  class:fade={hovering && !hovered}
  on:mouseover={mouseover}
  on:mouseout={mouseout}
  style="
    left: {x};
    top: {y};
    width: {(r + hoverR) * 2}px;
    height: {(r + hoverR) * 2}px;
  "
>

  <div
    bind:this={circle}
    class="circle" 
    style="
      background-color: {color};
      width: {r * 2}px;
      height: {r * 2}px;
    "
  />

  {#if label}
    <div class="label {label.align} {label.hideMobile?'hide-mobile':''}">
      <span>{d.name}</span>
      {#if label.extra}
        <span class="extra">{@html label.extra}</span>
      {/if}
    </div>
    {#if label.showValueX}
      <span style="right: {2 * r + hoverR + 3}px" class="label-x">{@html label.showValueX}</span>
    {/if}
    {#if label.showValueY}
        <span style="top: {2 * r + hoverR + 3}px"  class="label-y">{@html label.showValueY}</span>
    {/if}
  {/if}

</div>

<div
  class="dot" 
  class:hover={hover}
  style="
    left: {x};
    top: {y};
  "
/>

<div class="tooltip tooltip--{pos}" class:hover={hover} 
  style="
    left: {x};
    top: {y};
  "
>
  <div class="tooltip__icon" style:background-image={`url('${PATH}/food-icons-min/${d.id}.svg')`}></div>
  <div class="tooltip__data">
    <div class="tooltip__name"> {d.name} </div>
    <div class="tooltip__price"> Preis: {frmt(d.preis_pro_portion_2021)} € pro Portion </div>
    <div class="tooltip__co2"> CO₂: {frmt(d.co2_pro_portion)}kg pro Portion </div>
  </div>
</div>

<style>
  .food {
    position: absolute;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    z-index: 1;
    -webkit-tap-highlight-color: transparent;
    transition: opacity 0.2s ease;
  }

  .fade {
    opacity: 0.2;
  }


  .fade .label,
  .fade .label-x,
  .fade .label-y {
    opacity: 0;
  }

  .circle,
  .dot {
    position: absolute;
    top: 50%;
    left: 50%;
    opacity: 0.7;
    border-radius: 50%;
    transform: translate(-50%, -50%) scale(1);
    transform-origin: center center;
    transition: transform 0.3s ease;
  }

  .dot {
    opacity: 1;
    z-index: 2;
    width: 4px;
    height: 4px;
    background: #fff;
    pointer-events: none;
  }

  .hover {
    z-index: 3;
  }
  .dot.hover {
    z-index: 4;
  }

  .hover .circle {
    transform: translate(-50%, -50%) scale(2);
  }

  .hover .label {
    opacity: 0;
  }

  .tooltip {
    pointer-events: none;
    background: #fff;
    font-size: 14px;
    line-height: 17px;
    display: none;
    position: absolute;
    z-index: 5;
    display: none;
    padding: 5px;
    border-radius: 3px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    transform: translate(-50%, calc(-100% - 24px));
    white-space: nowrap;
    user-select: none;
  }

  .tooltip::after {
    content: ' ';
    position: absolute;
    top: 100%;
    left: 50%;
    display: block;
    width: 12px;
    height: 12px;
    background-color: #fff;
    border-radius: 0 0 1px 0;
    transform-origin: center;
    transform: translate(-50%, -50%) rotate(45deg);
    z-index: 3;
  }

  .tooltip--left {
    transform: translate(-20px, calc(-100% - 24px));
  }
  .tooltip--left::after {
    left: 20px;
  }

  .tooltip--right {
    transform: translate(calc(-100% + 20px), calc(-100% - 24px));
  }
  .tooltip--right::after {
    left: auto;
    right: 8px;
  }



  .tooltip__icon {
    display: inline-block;
    vertical-align: middle;
    width: 44px;
    height: 44px;
    margin-right: 5px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }

  .tooltip__data {
    display: inline-block;
    vertical-align: middle;
  }

  .tooltip__name {
    font-weight: bold;
  }

  .tooltip.hover {
    display: block;
  }

  .label {
    font-size: 13px;
    line-height: 13px;
    position: absolute;
    left: 50%;
    top: 50%;
    pointer-events: none;
    opacity: 1;
    transition: opacity 0.2s;
  }


  .label.top {
    transform: translate(-50%, calc(-100% - 13px));
  }

  .label.bottom {
    transform: translate(-50%, 13px);
  }

  .label.left {
    transform: translate(calc(-100% - 13px), -50%);
  }

  .label.right {
    transform: translate(13px, -50%);
  }

  .label .extra {
    font-size: 11px;
    line-height: 11px;
    white-space: nowrap;
  }

  .label-x {
    position: absolute;
    top: 50%;
    right: 50%;
    font-size: 11px;
    line-height: 11px;
    transform: translateY(-100%);
    border-bottom: 1px solid #1f1f1f;
    padding-right: 7px;
    padding-left: 7px;
    white-space: nowrap;
    pointer-events: none;
  }


  .label-x::after {
    content: ' ';
    width: 4px;
    height: 4px;
    position: absolute;
    right: 1px;
    bottom: -3px;
    transform-origin: center center;
    transform: rotate(45deg);
    border-top: 1px solid #1f1f1f;
    border-right: 1px solid #1f1f1f;
  }

  .label-y {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 11px;
    line-height: 11px;
    border-left: 1px solid #1f1f1f;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 2px;
    white-space: nowrap;
    pointer-events: none;
  }

  .label-y::after {
    content: ' ';
    width: 4px;
    height: 4px;
    position: absolute;
    left: -3px;
    top: 1px;
    transform-origin: center center;
    transform: rotate(-45deg);
    border-top: 1px solid #1f1f1f;
    border-right: 1px solid #1f1f1f;
  }

  @media (max-width: 480px) {
    .hide-mobile {
      display: none;
    }
  }
</style>
